<template>
  <q-layout view="hHh Lpr lff">
    <q-header elevated>
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />

        <q-toolbar-title>
          {{title}}
        </q-toolbar-title>

      </q-toolbar>
    </q-header>

    <q-drawer
      v-model="leftDrawerOpen"
      overlay behavior="desktop"
      :persistent="false"

      :breakpoint="500"
      content-class="bg-grey-2"
    >
      <q-list>
        <q-item-label header>Menu</q-item-label>
        <q-separator/>
        <q-item to="/" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="home" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Dashboard</q-item-label>
          </q-item-section>
        </q-item>
        <q-separator/>
        <q-item to="/doadores" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="assignment_ind" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Doadores</q-item-label>
          </q-item-section>
        </q-item>
        <q-item to="/campanhas" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="assignment_ind" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Campanhas</q-item-label>
          </q-item-section>
        </q-item>
        <q-separator/>
        <q-item to="/retorno_itau_boleto" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="chrome_reader_mode" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Upload Retorno Boleto Itau </q-item-label>
          </q-item-section>
        </q-item>
        <q-item to="/retorno_itau_debito" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="class" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Upload Retorno Débito Itau</q-item-label>
          </q-item-section>
        </q-item>
        <!--
        <q-item to="/returno_debito_santander" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="euro_symbol" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Upload Retorno Santander</q-item-label>
          </q-item-section>
        </q-item>

        <q-item to="/remessas" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="euro_symbol" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Gerador de Remessa</q-item-label>
          </q-item-section>
        </q-item>
        <q-separator/>
        -->
        <!--
        <q-item to="/email_sent" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="email" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Autorizador de email</q-item-label>
          </q-item-section>
        </q-item>
        <q-item to="/emails_report" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="email" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Relatório de email</q-item-label>
          </q-item-section>
        </q-item>
        -->
        <q-item to="/email_history" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="email" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Histórico de email</q-item-label>
          </q-item-section>
        </q-item>
        <!--
        <q-item to="/email-templates" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="email" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Templates de email</q-item-label>
          </q-item-section>
        </q-item>

        <q-item to="/historico_retorno" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="history" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Histórico de retornos</q-item-label>
          </q-item-section>
        </q-item>
        -->
        <!--
        <q-item to="/historico_rotinas_diarias" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="settings_backup_restore" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Histórico de rotinas diárias</q-item-label>
          </q-item-section>
        </q-item>

        <q-item to="/historico_geral" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="all_inbox" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Histórico geral</q-item-label>
          </q-item-section>
        </q-item>
        -->
        <q-separator/>
        <q-item to="/regua_relacionamento" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="all_inbox" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Régua de relacionamento</q-item-label>
          </q-item-section>
        </q-item>
        <q-separator/>
        <!--
        <q-item to="/donations_report" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="all_inbox" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Relatório de doações</q-item-label>
          </q-item-section>
        </q-item>

        <q-item to="/general_history_report" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="all_inbox" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Relatório do histórico geral</q-item-label>
          </q-item-section>
        </q-item>
        <q-separator/>

        <q-item clickable tag="a" target="_blank" href="https://crm-fundacao-do-cancer.s3.amazonaws.com/manual+do+crm.pdf">
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="description" />
          </q-item-section>
          <q-item-section>
            <q-item-label  >Manual do operador</q-item-label>
          </q-item-section>
        </q-item>
        -->
        <q-separator/>
        <!--<q-item to="/relator_donations" exact>
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="description" />
          </q-item-section>
          <q-item-section>
            <q-item-label  >Relatório de doações</q-item-label>
          </q-item-section>
        </q-item>-->
        <q-separator/>
        <q-item to="/" exact @click="logout">
          <q-item-section avatar>
            <q-avatar color="primary" text-color="white" icon="highlight_off" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Sair</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-drawer>

    <q-page-container>
      <router-view/>
    </q-page-container>
  </q-layout>
</template>

<script>
export default {
  name: 'LayoutDefault',

  data () {
    return {
      leftDrawerOpen: false,
      title: process.env.VUE_APP_NAME
    }
  },
  methods: {
    logout () {
      localStorage.setItem('token', '')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
